module.exports = __webpack_public_path__ + "static/img/create-page.3c23dbb1.svg";